export default __webpack_public_path__ + "static/media/efficiencybanner.9a43fac6.webp";